import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ProviderReferenceEmailLookup } from './ProviderReferenceEmailLookup';
import { ProviderReferenceForm } from './ProviderReferenceForm';

export const ProviderReferenceWrapper: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  if (!id) {
    return (
      <ProviderReferenceEmailLookup
        onFoundEndorsementId={(id) => {
          navigate(`/endorsement/provider-reference/${id}`);
        }}
      />
    );
  }

  return <ProviderReferenceForm id={id} />;
};

export default ProviderReferenceWrapper;
